import { useSelector } from "react-redux";
import { Loader } from "../components";
import { Header, Projects } from "../containers";

function Metrics() {
  const { data: metricsData } = useSelector((state) => state.fetchStatus);
  const { user } = useSelector((state) => state.auth);
  return (
    <>
      {!user || !metricsData ? <Loader /> : ""}
      {user && user.id && metricsData ?
        <main className="main flex flex-col mx-3 pt-10 ">
          <Header></Header>
          <Projects></Projects>
        </main>
        : null
      }
    </>
  );
}
export default Metrics;